<div class="loading-wrapper">
    <div class="loading">
        <svg
            class="loading__icon"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
            />
        </svg>
        <span class="loading__text"> Loading... </span>
    </div>
</div>

<style>
    @import "../../../main.css";

    .loading-wrapper {
        @apply reset flex-1 overflow-auto px-4 pb-8 !important;
    }

    .loading {
        @apply reset flex h-full w-full flex-col items-center justify-center !important;
    }
    .loading__icon {
        @apply reset h-8 w-8 animate-spin text-gray-400 !important;
    }
    .loading__text {
        @apply reset mt-2 text-gray-400 !important;
    }
</style>
